import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategorySidebarProps {
  activeId: string;
}

export default function CategorySidebar({ activeId }: CategorySidebarProps) {
  return (
    <aside className="w-full lg:w-64 shrink-0">
      <div className="lg:sticky lg:top-24 flex flex-col gap-4">
        <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <h3 className="font-heading text-sm font-semibold text-foreground-950 px-4 py-3 border-b border-background-200">
            切换赛事分类
          </h3>
          <ul className="p-2">
            {categories.map((cat) => {
              const active = cat.id === activeId;
              return (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className={`flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors ${
                      active ? 'bg-primary-100 text-primary-800' : 'hover:bg-background-100 text-foreground-700'
                    }`}
                  >
                    <i className={`${cat.icon} w-4 h-4 flex items-center justify-center ${active ? 'text-primary-700' : 'text-foreground-400'}`} />
                    <span className="flex-1 text-sm">{cat.name}</span>
                    <span className="text-[11px] text-foreground-500">{cat.count}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-4">
          <h3 className="font-heading text-sm font-semibold text-secondary-900 flex items-center gap-2">
            <i className="ri-information-line w-4 h-4 flex items-center justify-center" />
            数据说明
          </h3>
          <p className="mt-2 text-xs text-secondary-800 leading-relaxed">
            黑5综合指数为平台对赛事关注度与数据走势的综合评估值，数值越高代表当前赛事数据表现越活跃。
            所有数据均为前端演示示例。
          </p>
        </div>
      </div>
    </aside>
  );
}